import React from 'react'

function Loader() {
  return (
    <div className='loader-page'>
      <div className="loader">
        <div className="side"><span></span></div>
        <div className="side"><span></span></div>
        <div className="side"><span></span></div>
        <div className="side"><span></span></div>
        <div className="side"><span></span></div>
        <div className="side"><span></span></div>
        <p>&lt;/&gt;</p>
      </div>
    </div>
  )
}

export default Loader